import WematchEvent from "../../../../src/events/2022/04/wematch/main";
import * as React from 'react';
export default {
  WematchEvent,
  React
};